import type { CSSProperties } from "react";

/** Shared recharts styling for partner pages, driven by CSS theme variables. */
export const chartTooltipProps = {
  contentStyle: {
    backgroundColor: "var(--popover)",
    color: "var(--popover-foreground)",
    border: "1px solid var(--border)",
    borderRadius: 12,
    boxShadow: "var(--shadow-elevated)",
    fontSize: 12,
    padding: "8px 12px",
  } satisfies CSSProperties,
  labelStyle: { color: "var(--foreground)", fontWeight: 500 } satisfies CSSProperties,
  itemStyle: { color: "var(--body)" } satisfies CSSProperties,
};

export const chartAxisTick = { fontSize: 11, fill: "var(--muted-foreground)" };

export const CHART_COLORS = [
  "var(--chart-1)",
  "var(--chart-2)",
  "var(--chart-3)",
  "var(--chart-4)",
  "var(--chart-5)",
];
